import React from 'react';
import {Link} from "react-router-dom";

function ServiceItem2(props) {
    const serviceURL = `/service/${props.title.split(' ').join('-').toLowerCase()}/${props.id}`

    return (
        <div className="col-sm-6 col-lg-4" style={{maxWidth:"19%"}}>
        <div className="service-item" style={{height:"290px"}}>
            <figure className="service-thumb">
                {/* <Link to={`${process.env.PUBLIC_URL + serviceURL}`}> */}
                    <img src={process.env.REACT_APP_BASE_URL + props.thumb}  alt={props.title}/>
                {/* </Link> */}

                <figcaption className="service-txt">
                    <h6>{props.title}</h6>
                    <br/>
                    <h7>{props.text}</h7>
                </figcaption>
            </figure>
            <div className="service-content">
                <div className="service-content-inner" style={{direction:'ltr'}}>
                    <p>{props.title}</p>
                    <p>{props.text}</p>
                    <hr style={{width:'80%', height:"2px", margin:'auto'}}/>
                    <br/>
                    <p dangerouslySetInnerHTML={{__html: props.email}}/>
                    <p dangerouslySetInnerHTML={{__html: props.fax}}/>
                    <p dangerouslySetInnerHTML={{__html: props.phone}}/>

                </div>
            </div>
        </div>
    </div>
    );
}

export default ServiceItem2;